import { Box, ColorOptions, Spacer } from '@jfs/ui-new'
import { TextInputNew } from '../../components/AdminInputs'
import { ButtonNew } from '../../components/AdminButton'
import { isEmpty } from '@jfs/utils'
import { useState } from 'react'

export const MidVerify = ({ verifyMid, setFieldValue, fieldName, touched, error, label, placeholder }: any) => {
  const [value, setValue] = useState('')
  const handleOnChange = (text: string) => {
    setValue(text)
    fieldName && setFieldValue && setFieldValue(fieldName, text)
  }
  const handlePress = () => {
    !isEmpty(value) && verifyMid(value)
  }

  return (
    <Box flexDirection={'row'} align={'flex-start'}>
      <TextInputNew
        placeholder={placeholder}
        value={value}
        onChangeText={handleOnChange}
        {...textInputStyle}
        error={error}
        touched={touched}
      />
      <Spacer direction={'horizontal'} size={16} />
      <ButtonNew onPress={handlePress} height={36} width={96} title={'Verify'} disabled={isEmpty(value)} />
    </Box>
  )
}

const textInputStyle = {
  borderColor: '#d1d3e2' as ColorOptions,
  labelPaddingBottom: 8,
  borderRadius: 4,
  labelFontFamily: 'jiotype-bold',
  fontFamily: 'jiotype-medium',
  labelColor: '#6e707e' as ColorOptions,
  labelFontSize: 12,
  fontSize: 14,
  paddingHorizontal: 8,
  color: '#6e707e' as ColorOptions,
  paddingVertical: 8,
  focusBorderColor: '#d1d3e2' as ColorOptions,
  borderWidth: 2,
  onFocusBorderWidth: 2,
}
